// VFX: Cinematic Snow Drift
// Category: overlays  ·  Tags: snow, winter, particles, cinematic, weather
// Soft falling snow particles with depth layers and gentle wind drift, loopable.
import {
  AbsoluteFill,
  useCurrentFrame,
  useVideoConfig,
} from "remotion";
import React from "react";

type Flake = {
  x: number;
  y: number;
  size: number;
  speed: number;
  drift: number;
  opacity: number;
  blur: number;
};

const FLAKES: Flake[] = Array.from({ length: 80 }, (_, i) => {
  const seed = (i * 9301 + 49297) % 233280;
  const r = (n: number) => ((seed * (n + 1) * 1103) % 1000) / 1000;
  const layer = Math.floor(r(0) * 3);
  return {
    x: r(1) * 100,
    y: r(2) * 100,
    size: 2 + layer * 4 + r(3) * 4,
    speed: 0.15 + layer * 0.25 + r(4) * 0.2,
    drift: 0.4 + r(5) * 0.8,
    opacity: 0.35 + layer * 0.25,
    blur: layer === 0 ? 1.5 : layer === 1 ? 0.8 : 0,
  };
});

export default function FxSnowCinematicDriftLoop() {
  const frame = useCurrentFrame();
  const { durationInFrames } = useVideoConfig();
  return (
    <AbsoluteFill
      style={{
        background:
          "linear-gradient(180deg, #0a0e1a 0%, #1e293b 60%, #0a0e1a 100%)",
        overflow: "hidden",
      }}
    >
      {FLAKES.map((f, i) => {
        const progress = (frame * f.speed) / durationInFrames;
        const top = ((f.y + progress * 100) % 110) - 5;
        const left = f.x + Math.sin(frame * 0.02 + i) * f.drift * 2;
        return (
          <div
            key={i}
            style={{
              position: "absolute",
              top: `${top}%`,
              left: `${left}%`,
              width: f.size,
              height: f.size,
              borderRadius: "50%",
              background: "#f8fafc",
              opacity: f.opacity,
              filter: f.blur ? `blur(${f.blur}px)` : undefined,
              boxShadow: `0 0 ${f.size}px rgba(248,250,252,0.4)`,
            }}
          />
        );
      })}
    </AbsoluteFill>
  );
}

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
